// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/background-not-ready-nurse.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/images/background-not-ready-nurse-mobile.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/images/background-overdated.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/images/background-overdated-mobile.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --height-vh: 100vh;
}

.onetoone {
  height: var(--height-vh);
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  /*.main-inner--outils {
      .chat {
          top: 19rem;
      }
  }
  .main-inner--shared{
      .chat{
          top: 15rem;
      }
  }*/
}
.onetoone #main {
  flex: 1 1 auto;
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  background: #333c50;
  padding: 1rem 1.6rem;
  overflow: hidden;
}
.onetoone #main:hover .visio__control {
  opacity: 1;
  transform: translateY(0);
}
.onetoone .main-inner {
  border-radius: 1.25rem;
  background: #FDFBFB;
  width: 100%;
  height: calc(100% - 85px);
  position: relative;
  background: linear-gradient(0deg, #EEE7E1, #EEE7E1), #EEEEEE;
}
@media (max-width: 991px), (max-height: 699px) {
  .onetoone .main-inner {
    height: calc(100% - 40px);
  }
}
@media (max-width: 575px) {
  .onetoone .main-inner {
    height: calc(100% - 75px);
  }
}
.onetoone .chat {
  margin-top: 1.5rem;
  z-index: 25;
}
@media (max-width: 575px) {
  .onetoone #main {
    padding: 0px;
  }
  .onetoone .main-inner {
    border-radius: 0px;
  }
  .onetoone .chat {
    margin-top: 0px;
  }
}
.onetoone .main__visio {
  height: 100%;
}
.onetoone .main__visio .visio-actions {
  position: absolute;
  bottom: -88px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 40;
}
@media (max-width: 991px), (max-height: 699px) {
  .onetoone .main__visio .visio-actions {
    bottom: -55px;
  }
}
@media (max-width: 575px) {
  .onetoone .main__visio .visio-actions {
    left: 1rem;
    right: 1rem;
    bottom: -4.5rem;
    z-index: 20;
    transform: none;
  }
}
.onetoone .visio_video {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  flex-direction: column;
  height: 100%;
  height: 100%;
  width: 100%;
  /*
  .video-block {
      height: 100%;
      width: 100%;
      max-width: none;
  }
  .video-block__video {
      height: 100%;
      width: 100%;
      object-fit: cover;
  }*/
}
.onetoone .visio_video .video-block {
  position: relative;
  border-radius: 1.25rem;
  overflow: hidden;
  max-width: 240px;
  height: 200px;
  min-width: 15rem;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  z-index: 1;
  margin-right: 0px;
}
.onetoone .visio_video .video-block video {
  height: 100%;
  object-fit: cover;
}
.onetoone .visio_video .video-block .video-block__image {
  position: absolute;
  top: 0;
}
.onetoone .visio_video .video-block.video-block--full {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  max-width: 100%;
  margin: 0;
  z-index: 0;
}
.onetoone .visio_video .video-block .video-block-thumb-doc2u {
  display: none;
}
.onetoone .visio_video .video-block.video-block-mediaTag--screen-video.video-block--full {
  width: 70%;
  min-width: calc(100% - 15rem);
}
@media (max-width: 991px) {
  .onetoone .visio_video .video-block.video-block-mediaTag--screen-video.video-block--full {
    width: calc(100% - 11rem);
  }
}
@media (max-width: 575px) {
  .onetoone .visio_video .video-block.video-block-mediaTag--screen-video.video-block--full {
    width: 100%;
  }
}
.onetoone .visio_video .video-block.video-block-mediaTag--screen-video.video-block--full video {
  object-fit: contain;
}
.onetoone .visio_video .video-block.video-block-iframe iframe {
  height: 100%;
  width: 70%;
  min-width: calc(100% - 15rem);
}
@media (max-width: 991px) {
  .onetoone .visio_video .video-block.video-block-iframe iframe {
    width: calc(100% - 11rem);
  }
}
@media (max-width: 575px) {
  .onetoone .visio_video .video-block.video-block-iframe iframe {
    width: 100%;
  }
}
.onetoone .visio_video .video-block.video-block-iframe .video-block-thumb-doc2u {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #F5F1F1;
  justify-content: center;
  align-items: center;
  font-size: 55px;
  color: #00666F;
}
.onetoone .visio_video .video-block.video-block--doc2u {
  width: 100%;
}
.onetoone .visio_video .video-block.video-block--doc2u.video-block--full {
  height: 100%;
}
.onetoone .visio_video .video-block.video-block--doc2u.video-block--full .video-block-thumb-doc2u {
  display: none;
}
@media (max-width: 1199px) {
  .onetoone .visio_video .video-block {
    margin-right: 0rem;
    max-width: 15rem;
    min-width: auto;
  }
}
@media (max-width: 991px), (max-height: 699px) {
  .onetoone .visio_video .video-block {
    height: 147px;
    max-width: 11rem;
  }
}
@media (max-width: 575px) {
  .onetoone .visio_video .video-block {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    order: 2;
  }
  .onetoone .visio_video .video-block.video-block--full {
    position: static;
    height: auto;
    order: 1;
    flex: 1 1 auto;
  }
}
@media (max-width: 575px) {
  .onetoone .visio_video .video-block {
    border-radius: 0px;
  }
}
.onetoone .visio__thumbnails {
  position: absolute;
  bottom: 0;
  right: 1.5rem;
  z-index: 35;
  width: 374px;
  max-width: 100%;
}
.onetoone .visio__thumbnails .video-block {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.onetoone .visio__control {
  position: absolute;
  top: 0px;
  left: 1rem;
  max-width: calc(100% - 2rem);
  z-index: 18;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 0.25rem 1.25rem 0.5rem;
  background: rgba(253, 251, 251, 0.5);
  border-radius: 0px 0px 1.5rem 1.5rem;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.1), 0px 11px 11px 0px rgba(0, 0, 0, 0.09), 0px 25px 15px 0px rgba(0, 0, 0, 0.05), 0px 44px 18px 0px rgba(0, 0, 0, 0.01), 0px 69px 19px 0px rgba(0, 0, 0, 0);
  opacity: 0;
  transform: translateY(-50px);
  transition: all 0.3s linear;
}
@media (hover: none), (hover: on-demand), (-moz-touch-enabled: 1), (pointer: coarse) {
  .onetoone .visio__control {
    opacity: 1;
    transform: translateY(0);
  }
}
.onetoone .visio__medicalinfo {
  position: absolute;
  bottom: 0.5rem;
  left: 0.5rem;
}
.onetoone .visio__doctorform {
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 2;
}
.onetoone .visio__doctorform__toggle {
  position: relative;
  z-index: 1;
  text-align: center;
  max-width: 250px;
  width: 100%;
  height: 1.5rem;
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
  border-width: 1px;
  margin: 0px auto;
  background: rgba(253, 251, 251, 0.8);
  border: 1px solid #C9C5C5;
  border-bottom-width: 0px;
  box-shadow: 0px -3px 6px 0px rgba(0, 0, 0, 0.1), 0px -11px 11px 0px rgba(0, 0, 0, 0.09), 0px -25px 15px 0px rgba(0, 0, 0, 0.05), 0px -44px 18px 0px rgba(0, 0, 0, 0.01), 0px -69px 19px 0px rgba(0, 0, 0, 0);
  cursor: pointer;
}
.onetoone .visio__doctorform__toggle [class^=icon-],
.onetoone .visio__doctorform__toggle [class*=" icon-"] {
  display: inline-block;
  transition: all 0.3s linear;
}
.onetoone .visio__doctorform__toggle--toggled [class^=icon-],
.onetoone .visio__doctorform__toggle--toggled [class*=" icon-"] {
  transform: rotate(180deg);
}
.onetoone .main-inner--shared .video-block {
  width: 15rem;
  height: 15rem;
}
.onetoone .main-inner--shared .video-block.video-block--full {
  width: calc(100% - 16.5rem);
  height: 100%;
}
@media (max-width: 1199px) {
  .onetoone .main-inner--shared .video-block.video-block--full {
    width: calc(100% - 15rem);
  }
}
.onetoone .main-inner--shared .video-block.video-block--full.video-block--doc2u {
  width: 100%;
}
@media (max-width: 1199px) {
  .onetoone .main-inner--shared .video-block {
    height: 8rem;
  }
}
@media (max-width: 991px), (max-height: 699px) {
  .onetoone .main-inner--shared .video-block {
    width: 11rem;
    height: 9rem;
    max-width: none;
  }
  .onetoone .main-inner--shared .video-block.video-block--full {
    width: calc(100% - 11rem);
  }
}
@media (max-width: 575px) {
  .onetoone .main-inner--shared .video-block {
    width: 100%;
    max-width: 15rem;
    height: 7rem;
    height: 15vh;
  }
  .onetoone .main-inner--shared .video-block.video-block--full {
    width: 100%;
    height: auto;
  }
}
.onetoone .main-inner--killed {
  background-color: transparent;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: cover;
}
@media (max-width: 575px) {
  .onetoone .main-inner--killed {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center;
    background-size: cover;
  }
}
.onetoone .main-inner--overdated {
  background-color: transparent;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center;
  background-size: cover;
  position: relative;
}
@media (max-width: 575px) {
  .onetoone .main-inner--overdated {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center;
    background-size: cover;
  }
}
.onetoone .main-inner--overdated .overdated-top {
  text-align: center;
  color: #00666F;
  font-size: 1.5rem;
  font-family: "Exo", sans-serif;
  font-weight: 700;
  line-height: 1.5;
  max-width: 630px;
  width: 80%;
  position: absolute;
  top: 8%;
  left: 50%;
  transform: translateX(-50%);
}
@media (max-width: 575px) {
  .onetoone .main-inner--overdated .overdated-top {
    top: 5%;
  }
}
.onetoone .main-inner--overdated .overdated-bottom {
  text-align: center;
  max-width: 530px;
  width: 80%;
  position: absolute;
  bottom: 5%;
  left: 50%;
  transform: translateX(-50%);
}
@media (max-width: 575px) {
  .onetoone .main-inner--overdated .overdated-bottom {
    bottom: 1rem;
  }
}
.onetoone .main-inner--overdated .overdated-bottom__text {
  color: #00666F;
  background: #FDFBFB;
  font-family: "Exo", sans-serif;
  font-weight: 600;
  padding: 0.625rem;
  border-radius: 1rem;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.25);
  font-size: 1.25rem;
}
.onetoone .main-inner--overdated .overdated-bottom__button {
  padding: 0.625rem 1rem;
  font-family: "Exo", sans-serif;
  font-weight: 600;
  font-size: 1.125rem;
}
.onetoone.onetoone--welcome header, .onetoone.onetoone--medicalInfo header, .onetoone.onetoone--waitingAdminValidation header, .onetoone.onetoone--onBoarding header {
  display: none;
}
.onetoone.onetoone--welcome #main, .onetoone.onetoone--medicalInfo #main, .onetoone.onetoone--waitingAdminValidation #main, .onetoone.onetoone--onBoarding #main {
  background-color: transparent;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: cover;
}
@media (max-width: 575px) {
  .onetoone.onetoone--welcome #main, .onetoone.onetoone--medicalInfo #main, .onetoone.onetoone--waitingAdminValidation #main, .onetoone.onetoone--onBoarding #main {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center;
    background-size: cover;
  }
}
.onetoone.onetoone--welcome .modal--setting .modal__backdrop,
.onetoone.onetoone--welcome .modal--waiting .modal__backdrop, .onetoone.onetoone--medicalInfo .modal--setting .modal__backdrop,
.onetoone.onetoone--medicalInfo .modal--waiting .modal__backdrop, .onetoone.onetoone--waitingAdminValidation .modal--setting .modal__backdrop,
.onetoone.onetoone--waitingAdminValidation .modal--waiting .modal__backdrop, .onetoone.onetoone--onBoarding .modal--setting .modal__backdrop,
.onetoone.onetoone--onBoarding .modal--waiting .modal__backdrop {
  background: transparent;
}
@media (max-width: 575px) {
  .onetoone.onetoone--welcome .modal--setting .modal__inner, .onetoone.onetoone--medicalInfo .modal--setting .modal__inner, .onetoone.onetoone--onBoarding .modal--setting .modal__inner {
    width: 100%;
    max-width: 100%;
    max-height: calc(100% - 60px);
    margin-top: auto;
    border-radius: 0px;
    padding: 1rem 2rem;
  }
}
.onetoone.onetoone--medicalInfo .modal__inner, .onetoone.onetoone--onBoarding .modal__inner {
  overflow: hidden;
}
.onetoone.onetoone--medicalInfo .modal__body, .onetoone.onetoone--onBoarding .modal__body {
  max-height: calc(80vh - 172px);
  overflow: hidden;
  overflow-y: auto;
  margin-bottom: 100px;
}
.onetoone.onetoone--medicalInfo .modal__body .onboarding-config__actions, .onetoone.onetoone--onBoarding .modal__body .onboarding-config__actions {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  margin: 1rem auto;
}
.onetoone.onetoone--medicalInfo .modal__body .onboarding-config__devices_connected, .onetoone.onetoone--onBoarding .modal__body .onboarding-config__devices_connected {
  display: flex;
  justify-content: center;
}
@media (max-width: 1199px) {
  .onetoone {
    /*.main-inner--shared {
        .main__visio {
            width: 80%;
            width: calc(100% - 14.375rem);
        }

        .visio__thumbnails {
            width: 20%;
            width: 14.375rem;
            right: 0px;
        }
    }*/
  }
  .onetoone .visio__thumbnails {
    right: 0px;
  }
}
@media (max-width: 767px), (max-height: 575px) {
  .onetoone .visio__thumbnails {
    width: 15rem;
  }
}

.module-right {
  position: absolute;
  top: 0px;
  margin-top: -1rem;
  z-index: 20;
  right: 0px;
  width: 15rem;
  display: flex;
  flex-direction: column;
}
@media (max-width: 1199px) {
  .module-right {
    right: 0rem;
  }
}
@media (max-width: 991px), (max-height: 699px) {
  .module-right {
    width: 11rem;
  }
}
@media (max-height: 549px) {
  .module-right {
    position: absolute;
    top: 0px;
    /*.chat {
        position: absolute;
        bottom: 0;
    }*/
  }
}
@media (max-width: 575px) {
  .module-right {
    margin-top: 0px;
  }
}

.outils {
  background: #F5F1F1;
  border-radius: 0px 0px 1rem 1rem;
  border: 2px solid #333c50;
  border-top-width: 0px;
  border-bottom-width: 0px;
  border-bottom-width: 0px;
}
@media (max-width: 575px) {
  .outils {
    display: none !important;
  }
}
.outils__header {
  background: #1DADB5;
  font-size: 1rem;
  font-weight: 500;
  color: #FDFBFB;
  border-radius: 0px 0px 1rem 1rem;
  padding: 0.75rem 1.125rem;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  border-radius: 0px 0px 1rem 1rem;
  cursor: pointer;
  border: 2px solid #333c50;
  border-top-width: 0px;
  width: 100%;
  width: calc(100% + 4px);
  margin-left: -2px;
}
.outils__title {
  margin: 0px;
  margin-left: 0.75rem;
  color: inherit;
  font: inherit;
}
.outils__toggle {
  transition: all 300ms linear;
}
.outils__content {
  position: relative;
  height: auto;
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
  transition: all 300ms linear;
}
.outils__list {
  max-height: 50vh;
  overflow: auto;
}
.outils__list, .outils__settings {
  margin: 0px;
  list-style-type: none;
  color: #00666F;
  font-size: 0.875rem;
  font-weight: 500;
  padding: 0px 0.625rem;
  flex: 0 0 100%;
  transition: all 0.8s linear;
}
.outils__settings {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.outils__item {
  padding: 0.375rem 0px;
  display: flex;
  width: 100%;
  align-items: center;
  cursor: pointer;
  transition: background 0.4s linear;
}
.outils__item.outils__item--disabled {
  cursor: not-allowed;
}
.outils__item.outils__item--disabled .item__icon {
  border-color: #FF4958;
  color: #FF4958;
}
.outils__item:hover {
  background: rgb(252.83, 250.66, 250.66);
}
.outils__item + .outils__item {
  border-top: 1px solid #697F8C;
}
.outils__item .item__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.875rem;
  height: 1.875rem;
  background: #FDFBFB;
  border: 1px solid #00666F;
  border-radius: 50%;
  margin-right: 0.5rem;
}
.outils__item .item__icon i {
  font-size: 1.125rem;
}
.outils__item .item__icon .icon-spirometre {
  margin-left: 0.375rem;
}
.outils.opened {
  border-bottom-width: 2px;
}
.outils.opened .outils__toggle {
  transform: rotate(-180deg);
}
.outils.outils--selected .outils__settings {
  position: relative;
  z-index: auto;
  opacity: 1;
}
.outils.outils--selected .outils__list {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.outils__setting .osetting__header {
  padding: 0.375rem 0px;
  display: flex;
  width: 100%;
  align-items: center;
}
.outils__setting .osetting__title {
  display: flex;
  align-items: center;
}
.outils__setting .osetting__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.875rem;
  height: 1.875rem;
  background: #FDFBFB;
  border: 1px solid #00666F;
  border-radius: 50%;
  margin-right: 0.5rem;
  color: #00666F;
  font-size: 1.125rem;
}
.outils__setting .osetting__icon .icon-spirometre {
  margin-left: 0.375rem;
}
.outils__setting .osetting__close {
  margin-left: auto;
  width: 1.125rem;
  height: 1.125rem;
  cursor: pointer;
  color: #00666F;
  font-size: 1.125rem;
}
.outils__setting .osetting__close i {
  width: 100%;
  height: 100%;
}
.outils__setting .osetting__content {
  padding: 0.5rem 0px 0.75rem;
  border-top: 1px solid #697F8C;
}
.outils__setting .osetting__configs {
  margin-bottom: 0.625rem;
}
.outils__setting .osetting__config + .osetting__config {
  margin-top: 0.625rem;
}
.outils__setting .osetting__actions {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
}
.outils__setting .osetting__action {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FDFBFB;
  border: 1px solid #1DADB5;
  border-width: 2px;
  border-radius: 1rem;
  padding: 0.25rem;
  text-align: center;
  outline: none;
  box-shadow: none;
  width: 2.75rem;
  height: 2.75rem;
  transition: background 0.3s linear;
  font-size: 1.5rem;
  color: #1DADB5;
}
.outils__setting .osetting__action:hover, .outils__setting .osetting__action:focus {
  background: rgb(244.5, 234, 234);
}
.outils__setting .osetting__action + .osetting__action {
  margin-left: 0.5rem;
}
.outils__setting .osetting__action.osetting__action--active {
  color: #FF4958;
  border-color: #FF4958;
}
.outils__setting .osetting__action.osetting__action--pending {
  color: #F4981C;
  border-color: #F4981C;
}
@media (max-width: 991px), (max-height: 699px) {
  .outils {
    border-radius: 0px 0px 0.5rem 0.5rem;
  }
  .outils__header {
    font-size: 0.75rem;
    border-radius: 0px 0px 0.5rem 0.5rem;
    padding: 0.75rem 0.625rem;
  }
  .outils__title {
    margin-left: 0.625rem;
  }
  .outils__list, .outils__settings {
    font-size: 0.625rem;
    padding: 0px 0.5rem;
  }
  .outils__item .item__icon {
    width: 1.25rem;
    height: 1.25rem;
    margin-right: 0.25rem;
  }
  .outils__item .item__icon i {
    font-size: 0.75rem;
  }
  .outils__item .item__icon .icon-spirometre {
    margin-left: 0.125rem;
  }
  .outils__setting .osetting__icon {
    width: 1.25rem;
    height: 1.25rem;
    margin-right: 0.5rem;
    font-size: 0.75rem;
  }
  .outils__setting .osetting__icon .icon-spirometre {
    margin-left: 0.375rem;
  }
  .outils__setting .osetting__close {
    margin-left: auto;
    width: 0.75rem;
    height: 0.75rem;
    font-size: 0.75rem;
  }
  .outils__setting .osetting__action {
    border-radius: 0.5rem;
    padding: 0.125rem;
    width: 1.75rem;
    height: 1.75rem;
    font-size: 1rem;
    border-width: 1px;
  }
}

.visio-actions {
  display: inline-block;
}
.visio-actions .visio-actions__inner {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  max-width: 100%;
  margin: 0px auto;
  padding: 0.625rem;
  border-radius: 25px;
}
.visio-actions .visio-actions__button {
  display: flex;
  padding: 0px;
  position: relative;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  box-shadow: none;
  background: #1DADB5;
  color: #FDFBFB;
  transition: all 0.3s linear;
  width: 3.4375rem;
  height: 3.4375rem;
  font-size: 2.1875rem;
  border-radius: 50%;
  flex: 0 0 3.4375rem;
}
.visio-actions .visio-actions__button .btn__notif {
  top: -0.25rem;
  right: -0.25rem;
  width: 1.25rem;
  height: 1.25rem;
  font-size: 0.75rem;
  font-weight: 800;
  flex: 0 0 1.25rem;
}
.visio-actions .visio-actions__button:hover {
  background: #00666F;
}
.visio-actions .visio-actions__button + .visio-actions__button {
  margin-left: 0.625rem;
}
.visio-actions .visio-actions__button.button--hangup, .visio-actions .visio-actions__button.button--active {
  background: #FF4958;
}
.visio-actions .visio-actions__button.button--disabled {
  opacity: 0.5;
  cursor: wait;
}
.visio-actions .visio-actions__button.button--hangup:hover {
  background: rgb(255, 22, 41.2032967033);
}
.visio-actions .visio-actions__button.button--ring {
  background: #F4981C;
}
.visio-actions .visio-actions__button.button--ring:hover {
  background: rgb(210.7857142857, 125.3571428571, 10.2142857143);
}
@media (max-width: 991px), (max-height: 699px) {
  .visio-actions .visio-actions__button {
    width: 2rem;
    height: 2rem;
    flex: 0 0 2rem;
    border-radius: 1rem;
    font-size: 0.8rem;
  }
  .visio-actions .visio-actions__button + .visio-actions__button {
    margin-left: 0.375rem;
  }
}
@media (max-width: 575px) {
  .visio-actions .visio-actions__button {
    border-radius: 1.625rem;
    width: 3.25rem;
    height: 3.25rem;
    font-size: 1.5rem;
    flex: 0 0 3.25rem;
  }
}

.onetoone-type-extern .module-right, .onetoone-type-extern header, .onetoone-type-extern .button--chat {
  display: none;
}
.onetoone-type-extern .video-block--nurse {
  display: none;
}
.onetoone-type-extern video {
  display: none !important;
}
.onetoone-type-extern #webcam-preview {
  display: block !important;
}
.onetoone-type-extern .main__visio .video-block:not(.video-block--full) {
  display: none !important;
}
.onetoone-type-extern .video-block.video-block--full {
  width: 100% !important;
  height: 100% !important;
}

.volume-role-medecin {
  display: none;
}

.visio-top-action {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  box-shadow: none;
  background: #FDFBFB;
  color: #1DADB5;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.25);
  transition: all 0.3s linear;
  width: 1.875rem;
  height: 1.875rem;
  line-height: 1.875rem;
  font-size: 1rem;
  border-radius: 50%;
  flex: 0 0 1.875rem;
  margin: 0.125rem 0;
}

video[data-sessionrole=extern] {
  object-fit: contain !important;
}

.medical-visio-form {
  border-radius: 1rem;
  overflow: hidden;
  background: rgba(253, 251, 251, 0.5);
  box-shadow: 0px -4px 16px 0px rgba(0, 0, 0, 0.12);
}
.medical-visio-form__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.625rem 0.625rem 0rem 0.625rem;
}
.medical-visio-form__close {
  border: none;
  outline: none;
  box-shadow: none;
  margin-left: auto;
  font-size: 1rem;
  padding: 0px;
  background: transparent;
  color: #00666F;
}
.medical-visio-form__inputs {
  padding: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/OneToOne.scss","webpack://./src/styles/abstracts/_variables.scss","webpack://./src/styles/abstracts/_functions.scss"],"names":[],"mappings":"AAGA;EACI,kBAAA;AAFJ;;AAKA;EACI,wBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EA4VA;;;;;;;;;IAAA;AApVJ;AANI;EACI,cAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;EAGA,mBCOS;EDNT,oBAAA;EACA,gBAAA;AAMR;AAJQ;EACI,UAAA;EACA,wBAAA;AAMZ;AAFI;EAII,sBAAA;EACA,mBC3BO;ED4BP,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,4DAAA;AACR;AEsCE;EFhDE;IAWQ,yBAAA;EAGV;AACF;AEeE;EF9BE;IAcQ,yBAAA;EAKV;AACF;AAFI;EAIG,kBAAA;EACC,WAAA;AACR;AEME;EFHM;IACI,YAAA;EAAV;EAGM;IACI,kBAAA;EADV;EAIM;IACI,eAAA;EAFV;AACF;AAKI;EACI,YAAA;AAHR;AAKQ;EACI,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;AAHZ;AEGE;EFLM;IAOQ,aAAA;EADd;AACF;AEpBE;EFaM;IAUQ,UAAA;IACA,WAAA;IACA,eAAA;IACA,WAAA;IACA,eAAA;EACd;AACF;AAII;EACI,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EAmHA;;;;;;;;;;IAAA;AA1GR;AAPQ;EACI,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EAEA,gBAAA;EACA,2CAAA;EACA,UAAA;EAEA,iBAAA;AAOZ;AANgB;EACI,YAAA;EACA,iBAAA;AAQpB;AALgB;EACI,kBAAA;EACA,MAAA;AAOpB;AAJY;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;AAMhB;AAJY;EACI,aAAA;AAMhB;AAJY;EACI,UAAA;EACA,6BAAA;AAMhB;AALgB;EAHJ;IAIQ,yBAAA;EAQlB;AACF;AAPgB;EANJ;IAOQ,WAAA;EAUlB;AACF;AATgB;EACI,mBAAA;AAWpB;AAPgB;EACI,YAAA;EACA,UAAA;EACA,6BAAA;AASpB;AARoB;EAJJ;IAKQ,yBAAA;EAWtB;AACF;AAVoB;EAPJ;IAQQ,WAAA;EAatB;AACF;AAXgB;EACI,aAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,cC3JE;ADwKtB;AAVY;EAOI,WAAA;AAMhB;AAZgB;EACA,YAAA;AAchB;AAbgB;EACI,aAAA;AAepB;AErJE;EFwDM;IAoFQ,kBAAA;IACA,gBAAA;IAEA,eAAA;EAYd;AACF;AE5HE;EFwBM;IA0FQ,aAAA;IACA,gBAAA;EAcd;AACF;AE9IE;EFoCM;IA+FQ,WAAA;IAEA,iBAAA;IACA,kBAAA;IACA,QAAA;EAcd;EAbc;IACI,gBAAA;IACA,YAAA;IACA,QAAA;IACA,cAAA;EAelB;AACF;AElKE;EF0CM;IA6GQ,kBAAA;EAed;AACF;AACI;EACI,kBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AACR;AACQ;EACI,2CAAA;AACZ;AAGI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,4BAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,+BAAA;EACA,oCAAA;EACA,oCAAA;EACA,uMACI;EAKJ,UAAA;EACA,4BAAA;EACA,2BAAA;AANR;AAQQ;EAzBJ;IA0BQ,UAAA;IACA,wBAAA;EALV;AACF;AAQI;EACI,kBAAA;EACA,cAAA;EACA,YAAA;AANR;AASI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AAPR;AASQ;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,8BAAA;EACA,+BAAA;EACA,iBAAA;EACA,gBAAA;EACA,oCAAA;EACA,yBAAA;EAEA,wBAAA;EACA,4MAAA;EACA,eAAA;AARZ;AAUY;;EAEI,qBAAA;EACA,2BAAA;AARhB;AAYgB;;EAEE,yBAAA;AAVlB;AAkBQ;EACI,YAAA;EACA,aAAA;AAhBZ;AAiBY;EACI,2BAAA;EACA,YAAA;AAfhB;AExQE;EFqRU;IAIQ,yBAAA;EAblB;AACF;AAcgB;EACI,WAAA;AAZpB;AEhRE;EFkRM;IAeQ,YAAA;EAbd;AACF;AErPE;EFkPM;IAkBQ,YAAA;IACA,YAAA;IACA,eAAA;EAXd;EAYc;IACI,yBAAA;EAVlB;AACF;AE3QE;EF8PM;IA0BQ,WAAA;IACA,gBAAA;IACA,YAAA;IACA,YAAA;EATd;EAUc;IACI,WAAA;IACA,YAAA;EARlB;AACF;AA0BI;EACI,6BAAA;EACA,oEAAA;EACA,sBAAA;AAxBR;AElSE;EFuTE;IAMQ,oEAAA;IACA,sBAAA;EAvBV;AACF;AAyBI;EACI,6BAAA;EACA,oEAAA;EACA,sBAAA;EACA,kBAAA;AAvBR;AE9SE;EFiUE;IAOQ,oEAAA;IACA,sBAAA;EAtBV;AACF;AAwBQ;EACI,kBAAA;EACA,cCxXU;EDyXV,iBAAA;EACA,8BCxWI;EDyWJ,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,2BAAA;AAtBZ;AElUE;EF4UM;IAeQ,OAAA;EArBd;AACF;AAwBQ;EACI,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;AAtBZ;AEhVE;EF+VM;IAUQ,YAAA;EArBd;AACF;AAuBY;EACI,cCvZM;EDwZN,mBClaD;EDmaC,8BCvYA;EDwYA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,+CAAA;EACA,kBAAA;AArBhB;AAwBY;EACI,sBAAA;EACA,8BCjZA;EDkZA,gBAAA;EACA,mBAAA;AAtBhB;AAgCQ;EACI,aAAA;AA9BZ;AAgCQ;EACI,6BAAA;EACA,oEAAA;EACA,sBAAA;AA9BZ;AE7WE;EFwYM;IAMQ,oEAAA;IACA,sBAAA;EA7Bd;AACF;AAkCY;;;;;EACI,uBAAA;AA5BhB;AE1XE;EF8ZU;IACI,WAAA;IACA,eAAA;IACA,6BAAA;IACA,gBAAA;IACA,kBAAA;IACA,kBAAA;EAjCd;AACF;AAuCQ;EACI,gBAAA;AArCZ;AAwCQ;EACI,8BAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;AAtCZ;AAuCY;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,iBAAA;AArChB;AAuCY;EACI,aAAA;EACA,uBAAA;AArChB;AEtaE;EFxCF;IAggBQ;;;;;;;;;;;MAAA;EAnCN;EA8BM;IAEI,UAAA;EA7BV;AACF;AElbE;EFgeM;IACI,YAAA;EA3CV;AACF;;AAmDA;EACI,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,WAAA;EAEA,UAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAjDJ;AEzcE;EFifF;IAYQ,WAAA;EAhDN;AACF;AE9aE;EFidF;IAgBQ,YAAA;EA/CN;AACF;AAiDI;EAnBJ;IAoBQ,kBAAA;IACA,QAAA;IACA;;;MAAA;EA3CN;AACF;AE/cE;EFmeF;IA6BQ,eAAA;EA7CN;AACF;;AA+CA;EAEI,mBAAA;EACA,gCAAA;EACA,yBAAA;EACA,qBAAA;EACA,wBAAA;EAEA,wBAAA;AA9CJ;AE7dE;EFmgBF;IAYO,wBAAA;EA9CL;AACF;AAgDI;EACI,mBC/jBS;EDgkBT,eAAA;EACA,gBAAA;EACA,cC1kBO;ED2kBP,gCAAA;EACA,yBAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;AA9CR;AAiDI;EACI,WAAA;EACA,oBAAA;EACA,cAAA;EACA,aAAA;AA/CR;AAkDI;EACI,4BAAA;AAhDR;AAmDI;EACI,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,4BAAA;AAjDR;AAqDI;EACI,gBAAA;EACA,cAAA;AAnDR;AAsDI;EAEI,WAAA;EACA,qBAAA;EACA,cChnBc;EDinBd,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,2BAAA;AArDR;AAwDI;EACI,kBAAA;EACA,WAAA;EACA,UAAA;AAtDR;AAyDI;EACI,qBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,kCAAA;AAvDR;AAyDQ;EACI,mBAAA;AAvDZ;AAyDY;EACI,qBCnpBH;EDopBG,cCppBH;AD6lBb;AA2DQ;EACI,uCAAA;AAzDZ;AA4DQ;EACI,6BAAA;AA1DZ;AA6DQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBCvqBG;EDwqBH,yBAAA;EACA,kBAAA;EACA,oBAAA;AA3DZ;AA6DY;EACI,mBAAA;AA3DhB;AA8DY;EACI,qBAAA;AA5DhB;AAiEI;EACI,wBAAA;AA/DR;AAiEQ;EACI,0BAAA;AA/DZ;AAoEQ;EACI,kBAAA;EACA,aAAA;EACA,UAAA;AAlEZ;AAqEQ;EACI,kBAAA;EACA,WAAA;EACA,UAAA;AAnEZ;AAyEQ;EACI,qBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;AAvEZ;AA0EQ;EACI,aAAA;EACA,mBAAA;AAxEZ;AA2EQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBChuBG;EDiuBH,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cC1tBU;ED2tBV,mBAAA;AAzEZ;AA2EY;EACI,qBAAA;AAzEhB;AA6EQ;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cCvuBU;EDwuBV,mBAAA;AA3EZ;AA6EY;EACI,WAAA;EACA,YAAA;AA3EhB;AA+EQ;EACI,2BAAA;EACA,6BAAA;AA7EZ;AAgFQ;EACI,uBAAA;AA9EZ;AAmFY;EACI,oBAAA;AAjFhB;AAqFQ;EACI,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;AAnFZ;AAsFQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBCrxBG;EDsxBH,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kCAAA;EACA,iBAAA;EACA,cCzxBK;ADqsBjB;AAsFY;EAEI,gCAAA;AArFhB;AAwFY;EACI,mBAAA;AAtFhB;AAyFY;EACI,cC5yBH;ED6yBG,qBC7yBH;ADstBb;AAyFY;EACI,cC/yBA;EDgzBA,qBChzBA;ADytBhB;AErpBE;EFifF;IAkQQ,oCAAA;EA1FN;EA2FM;IACI,kBAAA;IACA,oCAAA;IACA,yBAAA;EAzFV;EA4FM;IACI,qBAAA;EA1FV;EA6FM;IAEI,mBAAA;IACA,mBAAA;EA5FV;EAiGU;IACI,cAAA;IACA,eAAA;IACA,qBAAA;EA/Fd;EAiGc;IACI,kBAAA;EA/FlB;EAkGc;IACI,qBAAA;EAhGlB;EAwGU;IACI,cAAA;IACA,eAAA;IACA,oBAAA;IACA,kBAAA;EAtGd;EAwGc;IACI,qBAAA;EAtGlB;EA0GU;IACI,iBAAA;IACA,cAAA;IACA,eAAA;IACA,kBAAA;EAxGd;EA2GU;IACI,qBAAA;IACA,iBAAA;IACA,cAAA;IACA,eAAA;IACA,eAAA;IACA,iBAAA;EAzGd;AACF;;AAkHA;EACI,qBAAA;AA/GJ;AAiHI;EACI,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EAGA,mBAAA;AAjHR;AAqHI;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,mBCn5BS;EDo5BT,cC55BO;ED65BP,2BAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;AAnHR;AAqHQ;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAnHZ;AAsHQ;EACI,mBCr6BU;ADizBtB;AAuHQ;EACI,qBAAA;AArHZ;AAwHQ;EAEI,mBCv7BC;ADg0Bb;AA0HQ;EACI,YAAA;EACA,YAAA;AAxHZ;AA2HQ;EACI,uCAAA;AAzHZ;AA4HQ;EACI,mBCn8BI;ADy0BhB;AA4HY;EACI,8DAAA;AA1HhB;AExwBE;EFy4BM;IACI,WAAA;IACA,YAAA;IACA,cAAA;IACA,mBAAA;IACA,iBAAA;EA9HV;EA+HU;IACI,qBAAA;EA7Hd;AACF;AEtyBE;EFw6BM;IACI,uBAAA;IACA,cAAA;IACA,eAAA;IACA,iBAAA;IACA,iBAAA;EA/HV;AACF;;AAoII;EACI,aAAA;AAjIR;AAmII;EACI,aAAA;AAjIR;AAmII;EACI,wBAAA;AAjIR;AAmII;EACI,yBAAA;AAjIR;AAoIQ;EACI,wBAAA;AAlIZ;AAqII;EACI,sBAAA;EAAwB,uBAAA;AAlIhC;;AAsIA;EACI,aAAA;AAnIJ;;AAqIA;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,mBCxgCW;EDygCX,cCjgCa;EDkgCb,+CAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAlIJ;;AAqIA;EACI,8BAAA;AAlIJ;;AA0IA;EACI,mBAAA;EACA,gBAAA;EACA,oCAAA;EACA,iDAAA;AAvIJ;AAyII;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;AAvIR;AA0II;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,cCziCc;ADi6BtB;AA2II;EACI,eAAA;AAzIR","sourcesContent":["@use './abstracts/variables' as *;\n@use './abstracts/functions';\n\n:root {\n    --height-vh: 100vh;\n}\n\n.onetoone {\n    height: var(--height-vh);    \n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    overflow: hidden;\n\n    #main {\n        flex: 1 1 auto;\n        display: flex;\n        flex-wrap: nowrap;\n        width: 100%;\n        // background: $color-darkgrey;\n        // padding: 1rem 44px;\n        background: $color__ternary;\n        padding: 1rem 1.6rem;\n        overflow: hidden;\n\n        &:hover .visio__control {\n            opacity: 1;\n            transform: translateY(0);\n        }\n    }\n\n    .main-inner {\n        // display: flex;\n        // flex-wrap: nowrap;\n        // flex-direction: row;\n        border-radius: 1.25rem;\n        background: $color__white;\n        width: 100%;\n        height: calc(100% - 85px);\n        position: relative;\n        background: linear-gradient(0deg, #EEE7E1, #EEE7E1), #EEEEEE;\n        @include functions.responsiveNewTablet {\n            height: calc(100% - 40px);\n        }\n        @include functions.responsiveSmartphone {\n            height: calc(100% - 75px);\n        }\n    }\n\n    .chat {\n        //position: absolute;\n        //top: 2.75rem;\n       // right: 1.5rem;\n       margin-top:1.5rem;\n        z-index: 25;\n    }\n\n    @include functions.responsiveSmartphone {\n        #main {\n            padding: 0px;\n        }\n\n        .main-inner {\n            border-radius: 0px;\n        }\n\n        .chat {\n            margin-top: 0px;\n        }\n    }\n\n    .main__visio {\n        height: 100%;\n\n        .visio-actions {\n            position: absolute;\n            bottom: -88px;\n            left: 50%;\n            transform: translateX(-50%);\n            z-index: 40;\n            @include functions.responsiveNewTablet {\n                bottom: -55px;\n            } \n            @include functions.responsiveSmartphone {\n                left: 1rem;\n                right: 1rem;\n                bottom: -4.5rem;\n                z-index: 20;\n                transform: none;\n            }\n           \n        }\n    }\n\n    .visio_video {\n        display: flex;\n        align-items: flex-end;\n        justify-content: flex-end;\n        flex-direction: column;\n        height: 100%;\n        height: 100%;\n        width: 100%;\n\n        .video-block {\n            position: relative;\n            border-radius: 1.25rem;\n            overflow: hidden;\n            max-width: 240px;\n            height: 200px;\n           \n            min-width: 15rem;\n            box-shadow: 0px 4px 4px rgba(black, 0.25);\n            z-index: 1;\n            // margin-right: 1.5rem;\n            margin-right: 0px;\n                video {\n                    height: 100%;\n                    object-fit: cover;\n                }\n           \n                .video-block__image{\n                    position: absolute;\n                    top:0;\n                }\n            \n            &.video-block--full {\n                position: absolute;\n                top: 0;\n                left: 0;\n                height: 100%;\n                width: 100%;\n                max-width: 100%;\n                margin: 0;\n                z-index: 0;\n            }\n            .video-block-thumb-doc2u{\n                display:none;\n            } \n            &.video-block-mediaTag--screen-video.video-block--full {\n                width: calc(100% - 30%);\n                min-width: calc(100% - 15rem);                \n                @media (max-width: 991px) {\n                    width: calc(100% - 11rem);\n                }\n                @media (max-width: 575px) {\n                    width: 100%;\n                }\n                video {\n                    object-fit: contain;\n                }\n            }           \n            &.video-block-iframe{\n                iframe{\n                    height:100%;                \n                    width: calc(100% - 30%);\n                    min-width: calc(100% - 15rem);\n                    @media (max-width: 991px) {\n                        width: calc(100% - 11rem);\n                    }\n                    @media (max-width: 575px) {\n                        width: 100%;\n                    }\n                }\n                .video-block-thumb-doc2u{\n                    display:flex;\n                    position: absolute;\n                    top:0;\n                    left: 0;\n                    width: 100%;\n                    height: 100%;\n                    background-color: #F5F1F1;\n                    justify-content: center;\n                    align-items: center;\n                    font-size:55px;\n                    color: $color__primary-dark;\n                }\n            }\n            &.video-block--doc2u {\n                &.video-block--full{\n                height:100%;\n                .video-block-thumb-doc2u{\n                    display:none\n                }\n                }\n                width: 100%;\n            }\n            @include functions.responsiveTablet {\n                margin-right: 0rem;\n                max-width: 15rem;\n                \n                min-width: auto;\n            }\n            @include functions.responsiveNewTablet {\n                height: 147px;\n                max-width: 11rem;\n            }\n\n            @include functions.responsiveWidth($screen-sm - 1) {\n                width: 100%;\n                //max-width: 15rem;\n                margin-left: auto;\n                margin-right: auto;\n                order: 2;\n                &.video-block--full {\n                    position: static;\n                    height: auto;\n                    order: 1;\n                    flex: 1 1 auto;\n                }\n            }\n\n            @include functions.responsiveSmartphone {\n                border-radius: 0px;\n            }\n        }\n\n        /*\n        .video-block {\n            height: 100%;\n            width: 100%;\n            max-width: none;\n        }\n        .video-block__video {\n            height: 100%;\n            width: 100%;\n            object-fit: cover;\n        }*/\n    }\n\n    .visio__thumbnails {\n        position: absolute;\n        bottom: 0;\n        right: 1.5rem;\n        z-index: 35;\n        width: 374px;\n        max-width: 100%;\n\n        .video-block {\n            box-shadow: 0px 4px 4px rgba(black, 0.25);\n        }\n    }\n\n    .visio__control {\n        position: absolute;\n        top: 0px;\n        left: 1rem;\n        max-width: calc(100% - 2rem);\n        z-index: 18;\n        display: flex;\n        flex-wrap: wrap;\n        flex-direction: row;\n        align-items: center;\n        justify-content: center;\n        gap:1rem;\n        padding: 0.25rem 1.25rem 0.5rem;\n        background: rgba(253, 251, 251, 0.5);\n        border-radius: 0px 0px 1.5rem 1.5rem;\n        box-shadow: \n            0px 3px 6px 0px rgba(black, 0.1),\n            0px 11px 11px 0px rgba(black, 0.09),\n            0px 25px 15px 0px rgba(black, 0.05),\n            0px 44px 18px 0px rgba(black, 0.01),\n            0px 69px 19px 0px rgba(black, 0);\n        opacity: 0;\n        transform: translateY(-50px);\n        transition: all 0.3s linear;\n\n        @media (hover: none), (hover: on-demand), (-moz-touch-enabled: 1), (pointer:coarse) {\n            opacity: 1;\n            transform: translateY(0);\n        }\n    }\n\n    .visio__medicalinfo {\n        position: absolute;\n        bottom: 0.5rem;\n        left: 0.5rem;\n    }\n\n    .visio__doctorform {\n        position: absolute;\n        bottom: 0px;\n        left: 0px;\n        right: 0px;\n        z-index: 2;\n\n        &__toggle {\n            position: relative;\n            z-index: 1;\n            text-align: center;\n            max-width: 250px;\n            width: 100%;\n            height: 1.5rem;\n            border-top-left-radius: 1.5rem;\n            border-top-right-radius: 1.5rem;\n            border-width: 1px;\n            margin: 0px auto;\n            background: rgba(253, 251, 251, 0.8);\n            border: 1px solid #C9C5C5;\n            //box-shadow: 0px -2px 5px 0px #C1C3C385;\n            border-bottom-width: 0px;\n            box-shadow: 0px -3px 6px 0px rgba(0, 0, 0, 0.1), 0px -11px 11px 0px rgba(0, 0, 0, 0.09), 0px -25px 15px 0px rgba(0, 0, 0, 0.05), 0px -44px 18px 0px rgba(0, 0, 0, 0.01), 0px -69px 19px 0px rgba(0, 0, 0, 0);\n            cursor: pointer;\n            \n            [class^=\"icon-\"],\n            [class*=\" icon-\"] {\n                display: inline-block;\n                transition: all 0.3s linear;\n            }\n\n            &--toggled {\n                [class^=\"icon-\"],\n                [class*=\" icon-\"] {\n                  transform: rotate(180deg);\n                }\n            }\n        }\n    }\n\n    // Outils shared/displayed\n    .main-inner--shared {\n        .video-block{\n            width: 15rem;\n            height : 15rem;\n            &.video-block--full {\n                width: calc(100% - 16.5rem);\n                height: 100%;\n                @include functions.responsiveTablet {\n                    width: calc(100% - 15rem);\n                }\n                &.video-block--doc2u {\n                    width: 100%;\n                }\n            }\n            \n            @include functions.responsiveTablet {\n                height: 8rem;\n            }\n            @include functions.responsiveNewTablet {\n                width: 11rem;\n                height: 9rem;\n                max-width: none;\n                &.video-block--full {\n                    width: calc(100% - 11rem);\n                }\n            }\n            @include functions.responsiveWidth($screen-sm - 1) {\n                width: 100%;\n                max-width: 15rem;\n                height: 7rem;\n                height: 15vh;\n                &.video-block--full {\n                    width: 100%;\n                    height: auto;\n                }\n            }\n        }\n    }\n\n    // Outils opened\n    /*.main-inner--outils {\n        .chat {\n            top: 19rem;\n        }\n    }\n    .main-inner--shared{\n        .chat{\n            top: 15rem;\n        }\n    }*/\n\n    // killed\n    .main-inner--killed {\n        background-color: transparent;\n        background: functions.image('background-not-ready-nurse.jpg') no-repeat center;\n        background-size: cover;\n\n        @include functions.responsiveSmartphone {\n            background: functions.image('background-not-ready-nurse-mobile.jpg') no-repeat center;\n            background-size: cover;\n        }\n    }\n    .main-inner--overdated {\n        background-color: transparent;\n        background: functions.image('background-overdated.jpg') no-repeat center;\n        background-size: cover;\n        position: relative;\n\n        @include functions.responsiveSmartphone {\n            background: functions.image('background-overdated-mobile.jpg') no-repeat center;\n            background-size: cover;\n        }\n\n        .overdated-top {\n            text-align: center;\n            color: $color__primary-dark;\n            font-size: 1.5rem;\n            font-family: $font__primary;\n            font-weight: 700;\n            line-height: 1.5;\n            max-width: 630px;\n            width: 80%;\n            position: absolute;\n            top: 8%;\n            left: 50%;\n            transform: translateX(-50%);\n\n            @include functions.responsiveSmartphone {\n                top: 5%;\n            }\n        }\n\n        .overdated-bottom {\n            text-align: center;\n            max-width: 530px;\n            width: 80%;\n            position: absolute;\n            bottom: 5%;\n            left: 50%;\n            transform: translateX(-50%);\n\n            @include functions.responsiveSmartphone {\n                bottom: 1rem;\n            }\n\n            &__text {\n                color: $color__primary-dark;\n                background: $color__white;\n                font-family: $font__primary;\n                font-weight: 600;\n                padding: 0.625rem;\n                border-radius: 1rem;\n                box-shadow: 1px 1px 4px 1px rgba(black, 0.25);\n                font-size: 1.25rem;\n            }\n\n            &__button {\n                padding: 0.625rem 1rem;\n                font-family: $font__primary;\n                font-weight: 600;\n                font-size: 1.125rem;\n            }\n        }\n    }\n\n    //\n    &.onetoone--welcome,\n    &.onetoone--medicalInfo,\n    &.onetoone--waitingAdminValidation,\n    &.onetoone--onBoarding {\n        header {\n            display: none;\n        }\n        #main {\n            background-color: transparent;\n            background: functions.image('background-not-ready-nurse.jpg') no-repeat center;\n            background-size: cover;\n\n            @include functions.responsiveSmartphone {\n                background: functions.image('background-not-ready-nurse-mobile.jpg') no-repeat center;\n                background-size: cover;\n            }\n        }\n\n        .modal--setting,\n        .modal--waiting {\n            .modal__backdrop {\n                background: transparent;\n            }\n        }\n    }\n    &.onetoone--welcome,\n    &.onetoone--medicalInfo,\n    &.onetoone--onBoarding {\n        @include functions.responsiveSmartphone {\n            .modal--setting .modal__inner {\n                width: 100%;\n                max-width: 100%;\n                max-height: calc(100% - 60px);\n                margin-top: auto;\n                border-radius: 0px;\n                padding: 1rem 2rem;\n            }\n        }\n    }\n\n    &.onetoone--medicalInfo,\n    &.onetoone--onBoarding{\n        .modal__inner{\n            overflow: hidden;\n        }\n\n        .modal__body{\n            max-height: calc(80vh - 172px);\n            overflow: hidden;\n            overflow-y: auto;\n            margin-bottom: 100px;\n            .onboarding-config__actions{ \n                position:absolute;\n                left:50%;\n                bottom:0;\n                transform: translateX(-50%);\n                margin: 1rem auto;\n            }\n            .onboarding-config__devices_connected{\n                display:flex;\n                justify-content: center;\n            }\n        }\n    }\n\n\n    @include functions.responsiveTablet {\n\n        .visio__thumbnails {\n            // width: 374px;\n            right: 0px;\n        }\n\n        /*.main-inner--shared {\n            .main__visio {\n                width: 80%;\n                width: calc(100% - 14.375rem);\n            }\n\n            .visio__thumbnails {\n                width: 20%;\n                width: 14.375rem;\n                right: 0px;\n            }\n        }*/\n    }\n\n    @include functions.responsiveMobile {\n        .visio__thumbnails {\n            width: 15rem;\n        }\n    }\n}\n\n\n// ---------------------------------\n// SELECTEUR DE CAPTEURS\n// ---------------------------------\n.module-right{\n    position: absolute;\n    top: 0px;\n    margin-top: -1rem;\n    z-index: 20;\n    // right: 1.5rem;\n    right: 0px;\n    width: 15rem;\n    display: flex;\n    flex-direction: column;\n    \n    @include functions.responsiveTablet {\n        right: 0rem;\n    }\n\n    @include functions.responsiveNewTablet {\n        width: 11rem;\n    }\n\n    @media (max-height: 549px) {\n        position: absolute;\n        top: 0px;\n        /*.chat {\n            position: absolute;\n            bottom: 0;\n        }*/\n    }\n\n    @include functions.responsiveSmartphone {\n        margin-top: 0px;\n    }\n}\n.outils {\n\n    background: #F5F1F1;\n    border-radius: 0px 0px 1rem 1rem;\n    border: 2px solid $color__ternary;\n    border-top-width: 0px;\n    border-bottom-width: 0px;\n\n    border-bottom-width: 0px;\n\n\n    @include functions.responsiveSmartphone {\n       display: none!important;\n    }\n\n    &__header {\n        background: $color__primary;\n        font-size: 1rem;\n        font-weight: 500;\n        color: $color__white;\n        border-radius: 0px 0px 1rem 1rem;\n        padding: 0.75rem 1.125rem;\n        display: flex;\n        flex-wrap: nowrap;\n        justify-content: center;\n        align-items: center;\n        border-radius: 0px 0px 1rem 1rem;\n        cursor: pointer;\n        border: 2px solid $color__ternary;\n        border-top-width: 0px;\n        width: 100%;\n        width: calc(100% + 4px);\n        margin-left: -2px;\n    }\n\n    &__title {\n        margin: 0px;\n        margin-left: 0.75rem;\n        color: inherit;\n        font: inherit;\n    }\n\n    &__toggle {\n        transition: all 300ms linear;\n    }\n\n    &__content {\n        position: relative;\n        height: auto;\n        overflow: hidden;\n        display: flex;\n        flex-wrap: nowrap;\n        align-items: center;\n        width: 100%;\n        transition: all 300ms linear;\n    }\n\n    // Liste capteur\n    &__list {        \n        max-height: 50vh;\n        overflow: auto;\n    }\n    \n    &__list,\n    &__settings {\n        margin: 0px;\n        list-style-type: none;\n        color: $color__primary-dark;\n        font-size: 0.875rem;\n        font-weight: 500;\n        padding: 0px 0.625rem;\n        flex: 0 0 100%;\n        transition: all 0.8s linear;\n    }\n\n    &__settings {\n        position: absolute;\n        z-index: -1;\n        opacity: 0;\n    }\n\n    &__item {\n        padding: 0.375rem 0px;\n        display: flex;\n        width: 100%;\n        align-items: center;\n        cursor: pointer;\n        transition: background 0.4s linear;\n\n        &.outils__item--disabled {\n            cursor: not-allowed;\n\n            .item__icon {\n                border-color: $color__red;\n                color: $color__red;\n            }\n        }\n\n        &:hover {\n            background: darken($color__white, 0.1);\n        }\n\n        &+.outils__item {\n            border-top: 1px solid $color-darkgrey;\n        }\n\n        .item__icon {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 1.875rem;\n            height: 1.875rem;\n            background: $color__white;\n            border: 1px solid $color__primary-dark;\n            border-radius: 50%;\n            margin-right: 0.5rem;\n\n            i {\n                font-size: 1.125rem;\n            }\n\n            .icon-spirometre {\n                margin-left: 0.375rem;\n            }\n        }\n    }\n\n    &.opened {\n        border-bottom-width: 2px;\n\n        .outils__toggle {\n            transform: rotate(-180deg);\n        }\n    }\n\n    &.outils--selected {\n        .outils__settings {\n            position: relative;\n            z-index: auto;\n            opacity: 1;\n        }\n\n        .outils__list {\n            position: absolute;\n            z-index: -1;\n            opacity: 0;\n        }\n    }\n\n    // Configuration capteur\n    &__setting {\n        .osetting__header {\n            padding: 0.375rem 0px;\n            display: flex;\n            width: 100%;\n            align-items: center;\n        }\n\n        .osetting__title {\n            display: flex;\n            align-items: center;\n        }\n\n        .osetting__icon {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 1.875rem;\n            height: 1.875rem;\n            background: $color__white;\n            border: 1px solid $color__primary-dark;\n            border-radius: 50%;\n            margin-right: 0.5rem;\n            color: $color__primary-dark;\n            font-size: 1.125rem;\n\n            .icon-spirometre {\n                margin-left: 0.375rem;\n            }\n        }\n\n        .osetting__close {\n            margin-left: auto;\n            width: 1.125rem;\n            height: 1.125rem;\n            cursor: pointer;\n            color: $color__primary-dark;\n            font-size: 1.125rem;\n\n            i {\n                width: 100%;\n                height: 100%;\n            }\n        }\n\n        .osetting__content {\n            padding: 0.5rem 0px 0.75rem;\n            border-top: 1px solid $color-darkgrey;\n        }\n\n        .osetting__configs {\n            margin-bottom: 0.625rem;\n            ;\n        }\n\n        .osetting__config {\n            &+.osetting__config {\n                margin-top: 0.625rem;\n            }\n        }\n\n        .osetting__actions {\n            display: flex;\n            flex-wrap: nowrap;\n            align-items: center;\n            justify-content: center;\n        }\n\n        .osetting__action {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            background: $color__white;\n            border: 1px solid $color__primary;\n            border-width: 2px;\n            border-radius: 1rem;\n            padding: 0.25rem;\n            text-align: center;\n            outline: none;\n            box-shadow: none;\n            width: 2.75rem;\n            height: 2.75rem;\n            transition: background 0.3s linear;\n            font-size: 1.5rem;\n            color: $color__primary;\n\n            &:hover,\n            &:focus {\n                background: darken($color__white, 5%);\n            }\n\n            &+.osetting__action {\n                margin-left: 0.5rem;\n            }\n\n            &.osetting__action--active {\n                color: $color__red;\n                border-color: $color__red;\n            }\n            &.osetting__action--pending {\n                color: $color__orange;\n                border-color: $color__orange;\n            }\n        }\n    }\n\n\n    @include functions.responsiveNewTablet {\n        border-radius: 0px 0px 0.5rem 0.5rem;\n        &__header {\n            font-size: 0.75rem;\n            border-radius: 0px 0px 0.5rem 0.5rem;\n            padding: 0.75rem 0.625rem;\n        }\n\n        &__title {\n            margin-left: 0.625rem;\n        }\n        // Liste capteur\n        &__list,\n        &__settings {\n            font-size: 0.625rem;\n            padding: 0px 0.5rem;\n        }\n    \n        &__item {\n    \n            .item__icon {\n                width: 1.25rem;\n                height: 1.25rem;\n                margin-right: 0.25rem;\n    \n                i {\n                    font-size: 0.75rem;\n                }\n    \n                .icon-spirometre {\n                    margin-left: 0.125rem;\n                }\n            }\n        }\n\n        // Configuration capteur\n        &__setting {\n    \n            .osetting__icon {\n                width: 1.25rem;\n                height: 1.25rem;\n                margin-right: 0.5rem;\n                font-size: 0.75rem;\n    \n                .icon-spirometre {\n                    margin-left: 0.375rem;\n                }\n            }\n    \n            .osetting__close {\n                margin-left: auto;\n                width: 0.75rem;\n                height: 0.75rem;\n                font-size: 0.75rem;\n            }\n    \n            .osetting__action {\n                border-radius: 0.5rem;\n                padding: 0.125rem;\n                width: 1.75rem;\n                height: 1.75rem;\n                font-size: 1rem;\n                border-width: 1px;\n            }\n        }\n    }\n}\n\n\n// ---------------------------------\n// VISIO ACTIONS\n// ---------------------------------\n.visio-actions {\n    display: inline-block;\n\n    .visio-actions__inner {\n        display: flex;\n        flex-wrap: nowrap;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n        max-width: 100%;\n        margin: 0px auto;\n        padding: 0.625rem;\n\n        // background: rgba(245, 241, 241, 0.5);\n        border-radius: 25px;\n        // box-shadow: 0px 4px 4px rgba(black, 0.25);\n    }\n\n    .visio-actions__button {\n        display: flex;\n        padding: 0px; // required for IOS browser \n        position: relative;\n        align-items: center;\n        justify-content: center;\n        border: none;\n        outline: none;\n        box-shadow: none;\n        background: $color__primary;\n        color: $color__white;\n        transition: all 0.3s linear;\n        width: 3.4375rem;\n        height: 3.4375rem;\n        font-size: 2.1875rem;\n        border-radius: 50%;\n        flex: 0 0 3.4375rem;\n\n        .btn__notif {\n            top: -0.25rem;\n            right: -0.25rem;\n            width: 1.25rem;\n            height: 1.25rem;\n            font-size: 0.75rem;\n            font-weight: 800;\n            flex: 0 0 1.25rem;\n        }\n\n        &:hover {\n            background: $color__primary-dark;\n        }\n\n        &+.visio-actions__button {\n            margin-left: 0.625rem;\n        }\n\n        &.button--hangup,\n        &.button--active {\n            background: $color__red;\n        }\n\n        &.button--disabled {\n            opacity: 0.5;\n            cursor: wait;\n        }\n\n        &.button--hangup:hover {\n            background: darken($color__red, 10%);\n        }\n\n        &.button--ring {\n            background: $color__orange;\n\n            &:hover {\n                background: darken($color__orange, 10%);\n            }\n        }\n    }\n\n\n    @include functions.responsiveNewTablet {\n        .visio-actions__button {\n            width: 2rem;\n            height: 2rem;\n            flex: 0 0 2rem;\n            border-radius: 1rem;\n            font-size: 0.8rem;\n            &+.visio-actions__button {\n                margin-left: 0.375rem;\n            }\n        }\n    }\n\n    @include functions.responsiveSmartphone {\n        .visio-actions__button {\n            border-radius: 1.625rem;\n            width: 3.25rem;\n            height: 3.25rem;\n            font-size: 1.5rem;\n            flex: 0 0 3.25rem;\n        }\n    }\n}\n\n.onetoone-type-extern {\n    .module-right, header, .button--chat {\n        display: none;\n    }\n    .video-block--nurse {\n        display: none;\n      }\n    video {\n        display: none !important;        \n    }\n    #webcam-preview {\n        display: block !important;\n    }\n    .main__visio{\n        .video-block:not(.video-block--full) {\n            display: none !important;  \n        }\n    }\n    .video-block.video-block--full {\n        width: 100% !important; height: 100% !important;\n    }\n}\n\n.volume-role-medecin {\n    display: none;\n}\n.visio-top-action {\n    display: flex;\n    position: relative;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    outline: none;\n    box-shadow: none;\n    background: $color__white;\n    color: $color__primary;\n    box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.25);\n    transition: all 0.3s linear;\n    width: 1.875rem;\n    height: 1.875rem;\n    line-height: 1.875rem;\n    font-size: 1rem;\n    border-radius: 50%;\n    flex: 0 0  1.875rem;\n    margin: 0.125rem 0;\n}\n\nvideo[data-sessionrole=\"extern\"] {\n    object-fit: contain !important;\n}\n\n\n\n// -------------------------\n// Medical Form visio\n// -------------------------\n.medical-visio-form {\n    border-radius: 1rem;\n    overflow: hidden;\n    background: rgba(253, 251, 251, 0.5);\n    box-shadow: 0px -4px 16px 0px rgba(0, 0, 0, 0.12);\n\n    &__header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 0.625rem 0.625rem 0rem 0.625rem;\n    }\n\n    &__close {\n        border: none;\n        outline: none;\n        box-shadow: none;\n        margin-left: auto;\n        font-size: 1rem;\n        padding: 0px;\n        background: transparent;\n        color: $color__primary-dark;\n    }\n\n    &__inputs {\n        padding: 0.5rem;\n    }\n}","// Screen sizes\n$screen-sm: 576px;\n$screen-md: 768px;\n$screen-lg: 992px;\n$screen-xl: 1200px;\n$screen-xxl: 1440px;\n$screen-full: 1920px;\n\n// Colors\n$color__white: #FDFBFB;\n$color__red: #FF4958;\n$color__orange: #F4981C;\n$color__black: #000000;\n$color_grey: #EEE7E1;\n$color-darkgrey: #697F8C;\n\n\n$color__primary: #1DADB5;\n$color__primary-alt: #007E94;\n$color__primary-dark: #00666F;\n$color__primary-light: #D3F1F2;\n\n$color__secondary-dark: #7D748D;\n$color__secondary: #ACA6B7;\n$color__secondary-light1: #E8E5EC;\n$color__secondary-light2: #F6F5F8;\n\n\n$color__ternary: #333c50;\n\n$theme__colors: (\n    \"primary\": $color__primary, \n    \"dark\": $color__black, \n    \"danger\": $color__red, \n    \"warning\": $color__orange\n);\n\n$font__primary: 'Exo', sans-serif;\n$font__secondary: 'Inter', sans-serif;\n\n$font__ternary: 'Filson Pro', sans-serif;\n$font__quaternary: 'Omnes', sans-serif;\n\n$size__text: 1rem;\n\n$font__text: $font__primary;\n$font__title: $font__primary;\n\n$border-radius1 : 10px;\n$border-radius2 : 15px;\n$border-radius3 : 20px;\n\n$marge1:5px;\n$marge2:10px;\n$marge3:5px;","@use './variables' as *;\n\n/// Base path for assets (fonts, images...),\n/// should not include trailing slash\n/// @access public\n/// @type String\n$asset-base-path: '../assets' !default;\n\n/// Asset URL builder\n/// @access private\n/// @param {String} $type - Asset type, matching folder name\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the asset\n@function asset($type, $file, $before: '') {\n  @return url($before + $asset-base-path + '/' + $type + '/' + $file);\n}\n\n/// Image asset helper\n/// @access public\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the image\n/// @require {function} asset\n@function image($file, $before: '') {\n  @return asset('images', $file, $before);\n}\n\n/// Image asset helper\n/// @access public\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the image\n/// @require {function} asset\n@function picto($file, $before: '') {\n  @return asset('images/pictos', $file, $before);\n}\n\n/// Font asset helper\n/// @access public\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the font\n/// @require {function} asset\n@function font($file, $before: '') {\n  @return asset('fonts', $file, $before);\n}\n\n\n// width < 1200px\n@mixin responsiveTablet {\n  @media (max-width: $screen-xl - 1px) {\n    @content;\n  }\n}\n\n// width < 768px OR height < 576px\n@mixin responsiveMobile {\n  @media (max-width: $screen-md - 1px), (max-height: $screen-sm - 1px) {\n    @content;\n  }\n}\n\n// width < 576px\n@mixin responsiveSmartphone {\n  @media (max-width: $screen-sm - 1px) {\n    @content;\n  }\n}\n\n@mixin responsiveWidth($width) {\n  @media (max-width: $width) {\n    @content;\n  }\n}\n\n@mixin responsiveHeight($height) {\n  @media (max-height: $height) {\n    @content;\n  }\n}\n\n@mixin responsiveWidthOrHeight($width, $height) {\n  @media (max-width: $width), (max-height: $height) {\n    @content;\n  }\n}\n\n@mixin responsiveNewTablet {\n  @include responsiveWidthOrHeight($screen-lg - 1px, 699px) {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
